(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-mystery-box-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yc-mystery-section]').forEach((section) => {
    const dialog = section.querySelector('[data-yc-mystery-dialog]');
    const image = dialog?.querySelector('img');
    section.querySelectorAll('[data-yc-mystery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !image) return;
        image.src = button.dataset.src || '';
        image.alt = button.dataset.alt || '';
        dialog.showModal();
      });
    });
    section.querySelector('[data-yc-mystery-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
